import React from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  animationSize?: number,
  animationThickness?: number
}

export default function LoadingOverlay(props: Props) {
  const {
    animationSize = 120,
    animationThickness = 16
  } = props;
  const c = useStyles({
    animationSize,
    animationThickness
  });

  return (
    <div className={c.loadingAnimationContainer}>
      <div className={c.loadingAnimationBackground} />
      <div className={c.loadingAnimation} />
    </div>
  );
}

const useStyles = createUseStyles({
  loadingAnimationContainer: {
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '6',
  },
  loadingAnimationBackground: {
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    position: 'absolute',
    backgroundColor: 'black',
    opacity: '40%'
  },
  loadingAnimation: (props: Props) => ({
    border: `${props.animationThickness}px solid white`,
    borderTop: `${props.animationThickness}px solid lightblue`,
    borderRadius: '50%',
    height: `${props.animationSize}px`,
    width: `${props.animationSize}px`,
    backgroundColor: 'transparent',
    animation: '$spin 2s linear infinite',
  }),
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
});
